import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import UsersList from 'src/components/_dashboard/usermanagement/UsersList';
// eslint-disable-next-line import/no-unresolved
import AddUserForm from 'src/components/_dashboard/usermanagement/AddUserForm';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUsersList } from '../../redux/slices/users__';
import { getClientList } from '../../redux/slices/client';
import { getProjectList } from '../../redux/slices/project';
import { getUserRoleList } from '../../redux/slices/user_role';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function Users() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { usersList, disableUsersList, isLoading } = useSelector((state) => state.users__);
  const { clientList } = useSelector((state) => state.client);
  const { projectList } = useSelector((state) => state.project);
  const { userRoleList } = useSelector((state) => state.user_role);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [userListStatus, setUserListStatus] = useState(true);
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentUser, setCurrentUser] = useState({});

  useEffect(() => {
    dispatch(getUsersList(true));
    dispatch(getUsersList(false));
    dispatch(getClientList(true));
    dispatch(getProjectList(true));
    dispatch(getUserRoleList(true));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUsersList(userListStatus));
  }, [userListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempUser = usersList.find((user) => user.id === editId);
      setCurrentUser(tempUser);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };
  return (
    <Page title="Users | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Users"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Users',
              href: PATH_DASHBOARD.general.users,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Users` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Add User
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && (
          <AddUserForm
            CLIENT_OPTION={clientList}
            PROJECT_OPTION={projectList}
            USER_ROLE_LIST={userRoleList}
            setVisibleComponent={setVisibleComponent}
          />
        )}
        {visibleComponent === 'List' && (
          <UsersList
            userListStatus={userListStatus}
            setUserListStatus={setUserListStatus}
            usersList={userListStatus ? usersList : disableUsersList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <AddUserForm
            setVisibleComponent={setVisibleComponent}
            currentUser={currentUser}
            editId={editId}
            CLIENT_OPTION={clientList}
            PROJECT_OPTION={projectList}
            USER_ROLE_LIST={userRoleList}
          />
        )}
      </Container>
    </Page>
  );
}
